<template>
  <div style="overflow: auto;height: 100%;width: 100%">

    <van-nav-bar :title="priceListClass.classname+''+useragent" left-text="返回" left-arrow @click-left="historyBack"/>
    <van-image width="100%" :height="height" :src="priceListClass.classimageurl" fit="cover"/>
    <van-row>
      <van-col span="24" style="padding-left: 20px;font-size: 22px">{{priceListClass.classname}}</van-col>
    </van-row>
    <van-divider></van-divider>
    <van-row v-if="priceListClass.attrArray!=null && priceListClass.attrArray.length<2" style="margin-bottom: 20px">
      <van-col span="12" style="padding-left: 20px">品类</van-col>
      <van-col span="12" style="text-align: right;padding-right: 20px">价格</van-col>
    </van-row>
    <van-row v-else style="margin-bottom: 20px">
      <van-col span="8" style="padding-left: 20px">品类</van-col>
      <van-col :span="parseInt(16/priceListClass.attrArray.length)" v-for="item in priceListClass.attrArray" :key="item">{{item}}</van-col>
    </van-row>

    <van-row v-if="priceListClass.attrArray!=null && priceListClass.attrArray.length<2" v-for="item in priceListData" :key="item.projectid" style="margin-bottom: 20px">
      <van-col span="12" style="padding-left: 20px" v-if="item.attr!='-'">{{item.projectname}}</van-col>
      <van-col span="12" style="text-align: right;padding-right: 20px" v-if="item.attr!='-'">{{item.attr}}</van-col>
      <van-col span="24" style="padding-left: 20px" v-if="item.attr=='-'">
        <van-divider content-position="left">{{item.projectname}}</van-divider>
      </van-col>
    </van-row>
    <van-row v-if="priceListClass.attrArray!=null && priceListClass.attrArray.length>=2" v-for="item in priceListData" :key="item.projectid" style="margin-bottom: 20px;font-size: 15px">
      <van-col span="8" style="padding-left: 20px" v-if="item.attr!='-'">{{item.projectname}}</van-col>
      <van-col :span="parseInt(16/item.attrArray.length)" v-for="val in item.attrArray" :key="val" v-if="item.attr!='-'">{{val}}</van-col>
      <van-col span="24" style="padding-left: 20px" v-if="item.attr=='-'">
        <van-divider content-position="left">{{item.projectname}}</van-divider>
      </van-col>
    </van-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      priceListClass: {},
      classid: "",
      height:"20rem",
      storeid: localStorage.getItem("storeid"),
      priceListData: [],
      useragent:"",
    }
  },
  created() {
    //this.useragent = navigator.userAgent;
    this.classid = this.$route.query.classid;
    this.getPriceListClassById();
    this.getPriceListByClassid();
    let sb=this.$getSb();
    if(sb=="iphone" || sb=="android"){
      this.height="10rem";
    }
  },
  methods: {
    getPriceListClassById() {
      this.$post("pricelist/getPriceListClassById", {storeid: this.storeid, classid: this.classid}).then(res => {
        if (res.sucess) {
          this.priceListClass = res.object;
          this.priceListClass.classimageurl=this.baseImageUrl+this.priceListClass.classimageurl;
          this.$set(this.priceListClass,"attrArray",this.priceListClass.attr.split(","));
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getPriceListByClassid() {
      this.$post("pricelist/getPriceListByClassid", {storeid: this.storeid, classid: this.classid}).then(res => {
        if (res.sucess) {
          this.priceListData = [];
          this.priceListData=res.object;
          if(this.priceListData!=null && this.priceListData.length>0){
            for(let val of this.priceListData){
              this.$set(val,"attrArray",val.attr.split(","));
            }
          }
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/pricelist/pricelistdetal.vue